import { app } from './index';

const aiBaseURL = process.env.REACT_APP_AI_BROKER_URL || 'http://localhost:3040';

const getAccessToken = async () => {
  try {
    if (app?.authentication?.getAccessToken) {
      const token = await app.authentication.getAccessToken();
      if (token) return token;
    }
  } catch (error) {
    // fallback below
  }

  const auth = app?.get?.('authentication');
  if (auth?.accessToken) return auth.accessToken;

  const localToken = window.localStorage.getItem('feathers-jwt');
  return localToken || null;
};

export const extractKycWithAiBroker = async ({
  producto,
  seed_nombres,
  seed_apellidoPaterno,
  seed_apellidoMaterno,
  id_institucion,
  documents = [],
  document_ids = []
}) => {
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Sesión no autenticada para extracción KYC.');
  }

  const fd = new FormData();
  fd.append('producto', producto || '');
  fd.append('seed_nombres', seed_nombres || '');
  fd.append('seed_apellidoPaterno', seed_apellidoPaterno || '');
  fd.append('seed_apellidoMaterno', seed_apellidoMaterno || '');
  fd.append('document_ids', JSON.stringify(document_ids || []));

  for (const d of documents) {
    if (d?.file) {
      fd.append('documents', d.file, `${d.type || 'documento'}__${d.file.name}`);
    }
  }

  const url = `${aiBaseURL}/kyc/extract?id_institucion=${encodeURIComponent(id_institucion || '')}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(id_institucion ? { 'x-institution-id': id_institucion } : {})
    },
    body: fd
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const errorMessage = payload?.detail || payload?.message || `Error al extraer KYC (HTTP ${response.status})`;
    throw new Error(errorMessage);
  }

  return payload;
};
